module.exports = __webpack_public_path__ + "static/media/H5ljlq.f0c31946.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/activity/FloatCouponSpecial/images/H5ljlq.gif
// module id = 1838
// module chunks = 6